import React, { useEffect, useState, useRef } from "react";
import BASEURL from "../../../Utils/Baseurl";
import DashboardLayout from "../../../../layoutcontainers/DashboardLayout";
import {
  Card,
  CardContent,
  CardHeader,
  FormControl,
  FormHelperText,
  Stack,
  ButtonGroup,
  Divider,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import MaterialTypography from "../../../../components/MaterialTypography";
import MaterialBox from "../../../../components/MaterialBox";
import MaterialButton from "../../../../components/MaterialButton";
import ConfirmationDialog from "../../../../components/Dialog/ConfirmationDialog";
import { useLocation, useNavigate } from "react-router-dom";
import MaterialDataGrid from "../../../../components/MaterialDataGrid";
import Swal from "sweetalert2";
import "./File.css";
import axios from "axios";
import { RiFileExcel2Line } from "react-icons/ri";
import { saveAs } from "file-saver";
import * as XLSX from "xlsx";
import { useUserDetails } from "../../../../context/auth";
import { createTypeTwoPayroll, getTypeTwoPayrollByMonthYear } from "../Queries";
import { Calculate } from "@mui/icons-material";

const AddPayroll = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const searchParams = new URLSearchParams(location.search);
  const modeParam = searchParams.get("mode");
  const monthParam = searchParams.get("month");
  const yearParam = searchParams.get("year");
  const tabParam = searchParams.get("tab");

  const savedMode = sessionStorage.getItem("payroll_mode");
  const savedMonth = sessionStorage.getItem("payroll_month");
  const savedYear = sessionStorage.getItem("payroll_year");
  const savedTab = sessionStorage.getItem("payroll_tab");

  const { exceldisplay, excelmonth, excelyear, setexceldisplay, setexcelmonth, setexcelyear } =
    useUserDetails();

  const isView =
    modeParam === "view" ||
    (modeParam !== "add" && (exceldisplay || savedMode === "view" || (Boolean(monthParam) && Boolean(yearParam))));

  const tabValue = tabParam || location.state?.tab || savedTab || "typeOne";
  const activeMonth = monthParam || excelmonth || savedMonth || "";
  const activeYear = yearParam || excelyear || savedYear || "";
  
  const [payrollData, setPayrollData] = useState({
    month: "",
    monthStatus: "",
    year: "",
    yearStatus: "",
  });
  const [Seeexport, setSeeexport] = useState(false);

  const payslipRef = useRef();
  const [payrolldeatils, setpayrolldeatils] = useState([]);
  const [togglePage, setTogglePage] = useState({
    view: false,
    edit: false,
  });
  const [pageState, setPageState] = useState({
    loading: false,
    error: false,
    message: "",
    state: "init",
  });
  const currentYear = new Date().getFullYear();
  const currentMonth = String(new Date().getMonth() + 1).padStart(2, "0");

  const startYear = 2000;
  const years = Array.from(
    { length: currentYear - startYear + 1 },
    (_, i) => currentYear - i,
  );

  const [selectedYear, setSelectedYear] = useState(currentYear);
  const [selectedMonth, setSelectedMonth] = useState(currentMonth);

  const getAvailableMonths = (year) => {
    const monthNames = [
      { value: "01", label: "January" },
      { value: "02", label: "February" },
      { value: "03", label: "March" },
      { value: "04", label: "April" },
      { value: "05", label: "May" },
      { value: "06", label: "June" },
      { value: "07", label: "July" },
      { value: "08", label: "August" },
      { value: "09", label: "September" },
      { value: "10", label: "October" },
      { value: "11", label: "November" },
      { value: "12", label: "December" },
    ];

    return monthNames.slice(0, year === currentYear ? currentMonth : 12);
  };

  const monthsOptions = getAvailableMonths(selectedYear);

  const staticKeys = [
    "Employee Pay Summary",
    "EMPLOYEE NAME",
    "DESIGNATION",
    "DATE OF JOINING",
    "PAY DATE",
    "PAY PERIOD ",
    "PAN NUMBER",
    "PF A/C NUMBER",
    "UAN NUMBER",
    "ESI NUMBER ",
  ];

  const Earnings = [
    "BASIC PAY",
    "HOUSE RENT ALLOWANCE",
    "SPECIAL ALLOWANCE",
    "LTA ALLOWANCE",
    "..",
    "Gross Earnings",
  ];
  const Deduction = [
    "PF AMOUNT",
    "ESIC Amount",
    "PROFESSIONAL TAX",
    "INCOME TAX",
    "GRATUITY",
    "GROSS DEDUCTIONS",
  ];

  // 1️⃣ Get all unique component names
  const allComponents = [
    ...new Set(
      payrolldeatils?.flatMap((item) =>
        JSON.parse(item?.breakdown || "[]").map((comp) => comp.componentName),
      ),
    ),
  ];

  // 2️⃣ Create dynamic columns for components
  const dynamicComponentColumns = allComponents.map((component) => ({
    field: component,
    headerName: component,
    width: 130,
    editable: false,
    sortable: true,
  }));

  // 3️⃣ Create rows with component monthly values
  const rows = payrolldeatils?.map((leave, index) => {
    const breakdownArray = JSON.parse(leave?.breakdown || "[]");

    const componentObject = breakdownArray.reduce((acc, comp) => {
      acc[comp.componentName] = comp.monthly;
      return acc;
    }, {});

    return {
      id: index + 1,
      firstName: leave?.user?.firstName + " " + leave?.user?.lastName,
      department: leave?.user?.department,
      dateOfJoining: leave?.user?.dateOfJoining,
      bankName: leave?.user?.bankDetails?.bankName,
      accountNumber: leave?.user?.bankDetails?.accountNumber,
      updatedCtc: leave?.updatedCtc,
      monthlyCtc: leave?.monthlyCtc,
      lossOfPayCount: leave?.lossOfPayCount,
      lossOfPayAmount: leave?.lossOfPayAmount,
      gross: leave?.gross,
      totalDeductions: leave?.totalDeductions,
      totalBenefits: leave?.totalBenefits,
      netPay: leave?.netPay,
      taxAmount: leave?.taxAmount,
      ptAmount: leave?.ptAmount,

      ...componentObject,
    };
  });

  // 4️⃣ Final table object
  const EarningListTable = {
    columns: [
        {
            field: "id",
            headerName: "S No",
            width: 80,
            sortable: true,
        },
        {
            field: "firstName",
            headerName: "Employee Name",
            width: 150,
            sortable: true,
        },
        {
            field: "department",
            headerName: "Department",
            width: 130,
            sortable: true,
        },
        {
            field: "dateOfJoining",
            headerName: "DOJ",
            width: 130,
            sortable: true,
        },
        {
            field: "bankName",
            headerName: "Bank Name",
            width: 130,
        },
        {
            field: "accountNumber",
            headerName: "Account Number",
            width: 150,
        },

        // Type One
        ...(tabValue === "typeOne"
            ? [
                  {
                      field: "updatedCtc",
                      headerName: "Annual CTC",
                      width: 120,
                  },
                  {
                      field: "gross",
                      headerName: "Total Gross",
                      width: 130,
                  },
              ]
            : []),

        // Type Two
        ...(tabValue === "typeTwo"
            ? [
                  {
                      field: "monthlyCtc",
                      headerName: "Monthly CTC",
                      width: 150,
                  },
              ]
            : []),

        {
            field: "totalDeductions",
            headerName: "Total Deduction",
            width: 140,
        },

        // Type One
        ...(tabValue === "typeOne"
            ? [
                  {
                      field: "totalBenefits",
                      headerName: "Total Benefits",
                      width: 120,
                  },
              ]
            : []),

        // Type One
        ...(tabValue === "typeOne"
            ? [
                  {
                      field: "netPay",
                      headerName: "Net Pay",
                      width: 150,
                  },
                  {
                      field: "taxAmount",
                      headerName: "Tax",
                      width: 120,
                  },
                  {
                      field: "ptAmount",
                      headerName: "PT",
                      width: 120,
                  },
              ]
            : []),

        ...dynamicComponentColumns,

        // Type Two
        ...(tabValue === "typeTwo"
            ? [
                  {
                      field: "lossOfPayCount",
                      headerName: "LOP Count",
                      width: 150,
                  },
                  {
                      field: "lossOfPayAmount",
                      headerName: "LOP Amount",
                      width: 150,
                  },
                  {
                      field: "netPay",
                      headerName: "Net Pay",
                      width: 150,
                  },
              ]
            : []),
    ],

    rows: rows || [],
};  

  useEffect(() => {
    if (isView) {
      setexceldisplay(true);
      if (activeMonth) setexcelmonth(activeMonth);
      if (activeYear) setexcelyear(activeYear);
      sessionStorage.setItem("payroll_mode", "view");
      if (activeMonth) sessionStorage.setItem("payroll_month", activeMonth);
      if (activeYear) sessionStorage.setItem("payroll_year", activeYear);
      sessionStorage.setItem("payroll_tab", tabValue);
      if (activeMonth && activeYear) {
        getpayroll(activeMonth, activeYear, tabValue);
      }
    } else {
      setexceldisplay(false);
      sessionStorage.setItem("payroll_mode", "add");
      sessionStorage.setItem("payroll_tab", tabValue);
    }
  }, [isView, activeMonth, activeYear, tabValue]);

  const getpayroll = async (targetMonth = activeMonth, targetYear = activeYear, targetTab = tabValue) => {
    const query = `
  query GetPayrollByMonthYear($month: Int!, $year: Int!) {
  payrollByMonthYear(month: $month, year: $year) {
    success
    message
    data {
      user {
        id
        username
        firstName
        lastName
        fathersName
        gender
        maritalStatus
        dateOfBirth
        dateOfJoining
        department
        aadharNumber
        panNumber
        bankDetails {
          bankName
          accountNumber
          ifscNumber
        }
      }
      month
      year
      updatedCtc
      gross
      totalDeductions
      taxAmount
      ptAmount
      totalBenefits
      netPay

      netpayWithOtammount
      overtime
      lossOfPayCount
      lossOfPayAmount
      overallSum
      breakdown
    }
  }
}
  `;

    const m = parseInt(targetMonth, 10);
    const y = parseInt(targetYear, 10);

    if (!m || !y) return;

    try {
      const variables = {
        month: m,
        year: y,
      };

      setPageState((prev) => ({ ...prev, loading: true }));

      const response = await axios.post(
        BASEURL,
        {
          query: targetTab === "typeOne" ? query : getTypeTwoPayrollByMonthYear,
          variables,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        },
      );
      if (targetTab === "typeOne") {
        let data = response.data?.data?.payrollByMonthYear?.data || [];
        const temp = data?.map((item) => ({
          ...item,
          components: JSON.parse(item?.breakdown || "[]").map((comp) => ({
            [comp?.componentName]: comp?.monthly,
          })),
        }));
        setpayrolldeatils(temp);
      } else if (targetTab === "typeTwo") {
        let data = response.data?.data?.typeTwoPayrollByMonthYear?.data || [];
        const temp = data?.map((item) => ({
          ...item,
          components: JSON.parse(item?.breakdown || "[]").map((comp) => ({
            [comp?.componentName]: comp?.monthly,
          })),
        }));
        setpayrolldeatils(temp);
      }

      setPageState((prev) => ({ ...prev, loading: false, state: "success" }));
    } catch (error) {
      console.log("Response Error:", error);
      setPageState((prev) => ({
        ...prev,
        loading: false,
        error: true,
        message: error.message,
      }));
      setConfirmationDialog({
        open: true,
        title: "Error message",
        message:
          "Sorry for your inconvience, there is some issue in our network. Please try again later.",
        showCancel: true,
        showConfirm: false,

        onCancel: () => {
          setConfirmationDialog((prev) => ({
            ...prev,
            open: false,
          }));
        },
      });
    }
  };

  const payrollSubmit = async () => {
    const query = `
        mutation payroll($month: Int!, $year: Int!) {
          FetchPayroll(month: $month, year: $year) {
            payrollData {
              user {
                id
                firstName
                lastName
                gender
                fathersName
                maritalStatus
                aadharNumber
                department
                dateOfBirth
                dateOfJoining
                panNumber
                uanNumber
              }
              bankDetails {
                accountNumber
                bankName
                ifscNumber
                branchName
                cifNumber
              }
              lossOfPayCount
              overtime
              otPerhourCharge
              OTAmount
              employeeSalary {
                ctc
                gross
                totalDeductions
                totalBenefits
                netPay
                netpayWithOtammount
                overallSum
                difference
                oneDaySalary
                lossOfPayAmount
                taxAmount
                     ptAmount
                breakdown {
                  type
                  componentName
                  percentage
                  monthly
                  yearly
                }
              }
            }
            updatedCtcArray
          }
        }
      `;

    try {
      const variables = {
        month: parseInt(selectedMonth, 10),
        year: parseInt(selectedYear, 10),
      };

      const response = await axios.post(
        BASEURL,
        {
          query: tabValue === "typeOne" ? query : createTypeTwoPayroll,
          variables,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        },
      );      
      
      // Handle the response
      if(tabValue === "typeOne"){
        
        if (response.data.errors) {
          console.error("GraphQL Errors:", response.data.errors);
  
          Swal.fire({
            position: "center",
            icon: "error",
            title: response.data.errors[0]?.message,
            showConfirmButton: false,
            timer: 2500,
          });
        } else {
          setSeeexport(true);
          Swal.fire({
            position: "center",
            icon: "success",
            title: "Payroll Created Successfully",
            showConfirmButton: false,
            timer: 2500,
          });
          let data = response.data.data.FetchPayroll.payrollData;
          setpayrolldeatils(data);
        }
      }else{
        if (response.data.data?.generateTypeTwoPayroll?.success) {
          setSeeexport(true);
          Swal.fire({
            position: "center",
            icon: "success",
            title: response.data.data?.generateTypeTwoPayroll?.message || "Payroll Created Successfully",
            showConfirmButton: false,
            timer: 2500,
          });
          let data = response.data.data.generateTypeTwoPayroll.payrollData;
          setpayrolldeatils(data);
        }
        else{
          Swal.fire({
            position: "center",
            icon: "error",
            title: response.data.errors[0]?.message || "Error Creating Payroll",
            showConfirmButton: false,
            timer: 2500,
          });
        }
      }
    } catch (error) {
      console.error("Error fetching payroll data:", error.message);
      Swal.fire({
        position: "center",
        icon: "error",
        title: error?.message || "Error Creating Payroll",
        showConfirmButton: false,
        timer: 2500,
      });
    }
  };

  const handleExportToExcel = () => {
    const ws = XLSX.utils.json_to_sheet(EarningListTable.rows);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Earnings Report");

    // Convert to binary and save
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], { type: "application/octet-stream" });

    saveAs(data, "EarningsReport.xlsx");
  };

  const [confirmationDialog, setConfirmationDialog] = useState({
    open: false,
    title: "",
    message: "",
    showCancel: true,
    showConfirm: true,
    customSection: null,
    onConfirm: () => {},
    onCancel: () => {},
  });

  const checkAllFields = () => {
    let allowSubmit = false;
    if (
      payrollData.monthStatus === "success" &&
      payrollData.yearStatus == "success"
    ) {
      allowSubmit = true;
    } else {
      allowSubmit = false;
    }
    return allowSubmit;
  };

  const handleCancel = () => {
    navigate("/pay-roll");
  };

  const handleAddPayroll = () => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message: "Are you sure do you want to submit your details.",
      showCancel: true,
      showConfirm: true,
      onConfirm: () => {
        payrollSubmit();
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };

  const onComponentSubmit = async () => {
    if (checkAllFields()) {
      try {
        navigate("/employee-salary");
      } catch (error) {
        console.error("Error submitting salary structure:", error);
        setConfirmationDialog({
          open: true,
          title: "Error massage",
          message:
            "Sorry for your inconvience, there is some issue in our network. Please try again later.",
          showCancel: true,
          showConfirm: false,

          onCancel: () => {
            setConfirmationDialog({
              ...confirmationDialog,
              open: false,
            });
          },
        });
      }
    } else {
      if (
        payrollData.monthStatus === "" ||
        payrollData.monthStatus === "unchecked"
      ) {
        setPayrollData({ ...payrollData, monthStatus: "uncheckedError" });
      } else if (
        payrollData.salaryStructureStatus === "" ||
        payrollData.salaryStructureStatus === "unchecked"
      ) {
        setPayrollData({
          ...payrollData,
          salaryStructureStatus: "uncheckedError",
        });
      } else if (
        payrollData.annualCtcStatus === "" ||
        payrollData.annualCtcStatus === "unchecked"
      ) {
        setPayrollData({ ...payrollData, annualCtcStatus: "uncheckedError" });
      }
    }
  };

  return (
    <DashboardLayout>
      {confirmationDialog.open && (
        <ConfirmationDialog
          open={confirmationDialog.open}
          title={confirmationDialog.title}
          message={confirmationDialog.message}
          showCancel={confirmationDialog.showCancel}
          showConfirm={confirmationDialog.showConfirm}
          customSection={confirmationDialog.customSection}
          onConfirm={confirmationDialog.onConfirm}
          onCancel={confirmationDialog.onCancel}
        />
      )}
      <Card sx={{ overflow: "visible" }}>
        <CardHeader
          title={
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              spacing={2}
            >
              <Stack direction="column" spacing={0}>
                  <MaterialTypography variant="h5" fontWeight="medium">
                    {isView ? "View Payroll" : "Add Payroll"}
                  </MaterialTypography>

                  <MaterialTypography variant="caption" fontWeight="medium">
                    {isView
                      ? "View and monitor the employee's payroll and salary details here."
                        : "Generate the employee's payroll and salary details here."}
                  </MaterialTypography>
              </Stack>
              {(isView || Seeexport) && (
                <ButtonGroup variant="outlined" aria-label="button group">
                  <MaterialButton
                    variant="gradient"
                    style={{ backgroundColor: "green", color: "white" }}
                    startIcon={<RiFileExcel2Line />}
                    onClick={handleExportToExcel}
                  >
                    Export
                  </MaterialButton>
                </ButtonGroup>
              )}
            </Stack>
          }
        />
        <CardContent>
          <MaterialBox>
            {!isView && (
              <>
                <Grid container spacing={1}>
                  <Grid size={{ xs: 5, sm: 4 }}>
                    <MaterialBox lineHeight={0} display="inline-block">
                      <MaterialTypography
                        component="label"
                        variant="caption"
                        fontWeight="bold"
                      >
                        Year <span style={{ color: "red" }}>*</span>
                      </MaterialTypography>
                    </MaterialBox>

                    <div className="dropdown-container">
                      <select
                        value={selectedYear}
                        onChange={(e) => setSelectedYear(e.target.value)}
                        className="custom-select"
                      >
                        <option value="" disabled>
                          Select...
                        </option>
                        {years.map((year) => (
                          <option key={year} value={year}>
                            {year}
                          </option>
                        ))}
                      </select>
                    </div>
                    {payrollData.monthStatus === "error" && (
                      <FormControl error>
                        <FormHelperText>Employee Name is required</FormHelperText>
                      </FormControl>
                    )}
                  </Grid>
                  <Grid size={{ xs: 5, sm: 4 }}>
                    <MaterialBox lineHeight={0} display="inline-block">
                      <MaterialTypography
                        component="label"
                        variant="caption"
                        fontWeight="bold"
                      >
                        Month <span style={{ color: "red" }}>*</span>
                      </MaterialTypography>
                    </MaterialBox>          

                    <div className="dropdown-container">
                      <select
                        value={selectedMonth}
                        onChange={(e) => setSelectedMonth(e.target.value)}
                        className="custom-select"
                      >
                        <option value="" disabled>
                          Select...
                        </option>
                        {monthsOptions.map((month) => (
                          <option key={month.value} value={month.value}>
                            {month.label}
                          </option>
                        ))}
                      </select>
                    </div>

                    {payrollData.monthStatus === "error" && (
                      <FormControl error>
                        <FormHelperText>Employee Name is required</FormHelperText>
                      </FormControl>
                    )}
                  </Grid>
                  <Grid sx={{ marginLeft: "2%", marginTop: "3%" }}>
                    <MaterialButton
                      variant="gradient"
                      color="dark"
                      size="medium"
                      //   disabled={!checkAllFields()}
                      startIcon={<Calculate/>  }
                      onClick={handleAddPayroll}
                    >
                      generate payroll
                    </MaterialButton>
                  </Grid>
                </Grid>
                <Divider/>
              </>
            )}
          </MaterialBox>
          {!isView && (
          <Stack direction="column">
            <MaterialTypography
              sx={{ mb: 1, color: "rgba(63, 81, 181, 0.83)" }}
              variant="h5"
              fontWeight="bold"
            >
              Payroll Details
            </MaterialTypography>
              <MaterialTypography
              variant="caption"
            >
              List of Payroll Details of employees that was generated
            </MaterialTypography>
          
          </Stack>
          )}
          <MaterialDataGrid
            rows={EarningListTable.rows}
            columns={EarningListTable.columns}
            checkboxSelection={false}
            isSelectable={false}
            loading={pageState.loading}
            localeText={{
              noRowsLabel: (
                <Stack
                  direction="column"
                  alignItems="center"
                  justifyContent="center"
                  spacing={1}
                >
                  <MaterialTypography
                    variant="body2"
                    fontWeight="medium"
                    color="text"
                  >
                    No details found
                  </MaterialTypography>
                </Stack>
              ),
            }}
            customHeight="100%"
            noSearch
            noPagination
            pageSize={5} // Add pagination with a small page size for better UX
            rowsPerPageOptions={[5, 10, 25]} // Allow users to choose rows per page
          />
        </CardContent>
      </Card>
    </DashboardLayout>
  );
};

export default AddPayroll;
